export interface SalesOrderHeaderNarrative {
  id: string;
  internalNotes: string;
  documentNotes: string;
  deliveryInstructions: string;
  productionNotes: string;
  salesDespatchNotes: string;
  salesInvoiceNotes: string;
  shippingNotes: string;
  deliveryTermNotes: string;
}
